import { classNames, Component, h, OmiProps, tag } from "omi";

import { tailwind } from "@/tailwind";

export type AccordionLink = {
  type: "link";
  href: string;
};

export type AccordionButton = {
  type: "button";
};

export type AccordionItemProps = {
  isActive: boolean;
  withActiveIndicator?: boolean;
  label: string;
  textSize?: "sm" | "md";
  textColor?: "dark-gray" | "light-grey";
  nested?: boolean;
} & (AccordionLink | AccordionButton);

@tag("nw-accordion-item")
export class NwAccordionItem extends Component<AccordionItemProps> {
  static css = [tailwind];
  static propTypes = {
    label: String,
    href: String,
    isActive: Boolean,
    textSize: String,
    textColor: String,
    withActiveIndicator: Boolean,
    nested: Boolean,
  };

  render({
    isActive,
    label,
    href,
    textSize = "md",
    textColor = "dark-gray",
    withActiveIndicator = true,
    nested = false,
  }: OmiProps<AccordionItemProps>) {
    return (
      <div
        class={classNames("cursor-pointer rounded-md select-none transition-all hover:bg-secondary mb-1", {
          "bg-primary": isActive,
          "text-sm": textSize === "sm",
          "text-md p-1": textSize === "md",
        })}
        tabIndex={-1}
      >
        <a href={href} title={label}>
          <div
            class={classNames("py-2 pr-4 space-x-3 flex items-center", {
              "text-secondary": textColor === "dark-gray",
              "text-quaternary": textColor === "light-grey",
              "pl-3": nested,
              "pl-8": !nested,
            })}
          >
            <slot></slot>
            {isActive && withActiveIndicator && <div class="shrink-0 size-2 bg-leather rounded-full"></div>}
            <p class="truncate" title={label}>
              {label}
            </p>
          </div>
        </a>
      </div>
    );
  }
}
